"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Div = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var StyledDiv = _styledComponents["default"].div.withConfig({
  displayName: "element__StyledDiv",
  componentId: "sc-1pm9u1k-0"
})(["font-family:'ONYOneFont','Helvetica',sans-serif;font-size:14px;line-height:17px;color:#17181a;"]);
var Div = exports.Div = function Div(_ref) {
  var element = _ref.element,
    attributes = _ref.attributes,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledDiv, (0, _extends2["default"])({}, attributes, {
    className: className,
    style: element.style,
    customAttr: element.customAttr
  }), children);
};
Div.propTypes = {
  children: _propTypes["default"].node,
  attributes: _propTypes["default"].elementType,
  style: _propTypes["default"].object,
  className: _propTypes["default"].string,
  element: _propTypes["default"].shape({
    style: _propTypes["default"].string.isRequired
  }).isRequired
};
Div.defaultProps = {
  children: null,
  attributes: [],
  style: {},
  className: ''
};
var defaultDiv = {
  div: {
    component: Div,
    type: 'div',
    rootProps: {
      className: 'slate-div'
    }
  }
};
var _default = exports["default"] = defaultDiv;